/* Beylora wedding-band picker (2026-08-10).
   Loads ONLY on band PDPs (Material-only products; variant-main-picker gates the
   include on product type). The engagement split engine
   (beylora-variant-split-dynamic-20260808.js) never loads here and vice versa.

   Scope, deliberately small:
   - ring-size chips -> hidden properties[Ring Size] input (+ pressed states)
   - capture-phase ATC gate: no size, no add; reveal the note, never flash "added"
   - survives section morphs after material changes (module state + re-sync)
   Material switching itself is native radios handled by the theme's
   variant-picker component; price labels re-render server-side per morph. */

let activeRingSize = '';

function syncPressed(group, selector, chosen) {
  group.querySelectorAll(selector).forEach((btn) => {
    const on = btn === chosen;
    btn.classList.toggle('is-selected', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
}

function syncRingSizeProperty(explicitSize) {
  const size = explicitSize != null ? explicitSize : activeRingSize;
  activeRingSize = size;
  document.querySelectorAll('[data-beylora-ring-size-property-input]').forEach((input) => {
    if (input.value !== size) input.value = size;
  });
  if (!size) return;
  document.querySelectorAll('[data-beylora-ring-size-property]').forEach((group) => {
    const match = group.querySelector(
      `[data-beylora-ring-size-choice][data-ring-size="${CSS.escape(size)}"]`
    );
    if (match) syncPressed(group, '[data-beylora-ring-size-choice]', match);
  });
}

function chooseRingSize(button) {
  const size = button.dataset.ringSize || '';
  if (!size) return;
  syncRingSizeProperty(size);
  const note = document.querySelector('[data-beylora-size-note]');
  if (note) note.setAttribute('hidden', '');
  document.querySelectorAll('.beylora-size-needed').forEach((g) => g.classList.remove('beylora-size-needed'));
}

function revealRingSizeGate() {
  const note = document.querySelector('[data-beylora-size-note]');
  if (note) note.removeAttribute('hidden');
  const group = document.querySelector('[data-beylora-ring-size-property]');
  if (group) {
    group.classList.add('beylora-size-needed');
    const first = group.querySelector('[data-beylora-ring-size-choice]');
    if (first) first.focus({ preventScroll: false });
    group.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

function gateApplies() {
  return !!document.querySelector('[data-beylora-ring-size-property-input]');
}

function gateCartAction(event) {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;
  const control = target.closest(
    'button[name="add"], button.add-to-cart-button, .shopify-payment-button__button, form[action*="/cart/add"] button'
  );
  const submittedAddForm =
    event.type === 'submit' && target.matches?.('form[action*="/cart/add"], form[action*="/cart"]');
  if (!control && !submittedAddForm) return;

  const size = activeRingSize;
  if (!size && gateApplies()) {
    event.preventDefault();
    event.stopPropagation();
    /* the theme's own click delegate can already be flashing the success state
       when we block; strip it now and on the next frames (proven pattern from
       the engagement gate) */
    const stripAdded = () => {
      document
        .querySelectorAll('.add-to-cart-button[data-added], [name="add"][data-added]')
        .forEach((b) => b.removeAttribute('data-added'));
    };
    stripAdded();
    requestAnimationFrame(stripAdded);
    window.setTimeout(stripAdded, 60);
    window.setTimeout(stripAdded, 300);
    revealRingSizeGate();
    return;
  }
  if (size) syncRingSizeProperty(size);
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const chip = event.target.closest('[data-beylora-ring-size-choice]');
  if (chip) {
    event.preventDefault();
    chooseRingSize(chip);
  }
}, false);

/* gate registers at capture phase so it runs before the theme's cart handlers */
document.addEventListener('click', gateCartAction, true);
document.addEventListener('submit', gateCartAction, true);

/* material changes morph the section and re-render the size fieldset fresh;
   re-assert the chosen size on whatever DOM arrives */
document.addEventListener('variant:update', () => {
  window.setTimeout(() => syncRingSizeProperty(), 120);
  window.setTimeout(() => syncRingSizeProperty(), 600);
});
if (window.MutationObserver) {
  const root = document.querySelector('#MainContent') || document.body;
  new MutationObserver(() => {
    if (activeRingSize) syncRingSizeProperty();
  }).observe(root, { childList: true, subtree: true });
}

/* Price-truth guard (2026-08-10, Joe order): band pages have no split engine,
   so stale page-cache prices would sit uncorrected. One product.js fetch (the
   live truth) rewrites the head price line, sticky price, and every metal
   tile's delta+absolute label. Boot + after every morph. */
let bandTruthPromise = null;
function bandTruth() {
  if (!bandTruthPromise) {
    const m = window.location.pathname.match(/\/products\/[^/?#]+/);
    bandTruthPromise = m
      ? fetch(m[0] + '.js', { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null)
      : Promise.resolve(null);
  }
  return bandTruthPromise;
}
const wholeMoney = (cents) => '$' + Math.round(cents / 100).toLocaleString('en-US');
async function reconcileBandPrices() {
  const product = await bandTruth();
  if (!product || !Array.isArray(product.variants)) return;
  const byMetal = new Map(product.variants.map((v) => [v.option1, v]));
  const tiles = [...document.querySelectorAll('.beylora-material-choice')];
  if (!tiles.length) return;
  const metalOf = (tile) => (tile.textContent.match(/1[48]k [A-Za-z]+ Gold|Platinum/) || [null])[0];
  const selTile = tiles.find((t) => t.querySelector('input:checked, input[data-current-checked="true"]'));
  const selVar = selTile ? byMetal.get(metalOf(selTile)) : null;
  if (!selVar) return;
  tiles.forEach((tile) => {
    const v = byMetal.get(metalOf(tile));
    const label = tile.querySelector('[data-beylora-price-label]');
    if (!v || !label) return;
    const delta = v.price - selVar.price;
    /* same order as the ring tiles and the server render: the price first, then Selected, Same price or the change */
    const note = tile === selTile ? 'Selected' : delta === 0 ? 'Same price' : (delta > 0 ? '+' : '-') + wholeMoney(Math.abs(delta));
    label.textContent = '';
    label.appendChild(document.createTextNode(wholeMoney(v.price)));
    const abs = document.createElement('small');
    abs.className = 'beylora-option-abs';
    abs.textContent = note;
    label.appendChild(abs);
  });
  const head = document.querySelector('.beylora-c-pdp-buy__price');
  if (head) {
    /* the same markup the server renders (snippets/beylora-c-pdp-buy.liquid), so the band line reads like the ring line:
       "$800 the complete band", with the was-price and offer on a quiet second line */
    const span = (cls, text) => {
      const el = document.createElement('span');
      el.className = cls;
      if (text != null) el.textContent = text;
      return el;
    };
    const now = span('beylora-c-pdp-buy__price-now');
    now.appendChild(span('beylora-c-pdp-buy__amount', wholeMoney(selVar.price)));
    now.appendChild(document.createTextNode(' '));
    now.appendChild(span('beylora-c-pdp-buy__ctx', 'the complete band'));
    head.textContent = '';
    head.appendChild(now);
    if (Number.isFinite(selVar.compare_at_price) && selVar.compare_at_price > selVar.price) {
      const was = span('beylora-c-pdp-buy__wasline');
      const msrp = document.createElement('s');
      msrp.className = 'beylora-c-pdp-buy__msrp';
      msrp.textContent = wholeMoney(selVar.compare_at_price);
      was.appendChild(msrp);
      was.appendChild(span('beylora-c-pdp-buy__off', Math.round(((selVar.compare_at_price - selVar.price) * 100) / selVar.compare_at_price) + '% off'));
      head.appendChild(was);
    }
  }
  const sticky = document.querySelector('.beylora-c-pdp-sticky__price');
  if (sticky) sticky.textContent = wholeMoney(selVar.price);
}
reconcileBandPrices();
document.addEventListener('variant:update', () => {
  window.setTimeout(reconcileBandPrices, 250);
  window.setTimeout(reconcileBandPrices, 900); /* after the morph settles */
});

/* replay a pre-module tap (same early-click contract as the engagement engine) */
window.__beyloraSplitReady = true;
if (window.__beyloraPendingSplitClick instanceof Element) {
  const pending = window.__beyloraPendingSplitClick;
  window.__beyloraPendingSplitClick = null;
  if (pending.matches('[data-beylora-ring-size-choice]')) chooseRingSize(pending);
}
